/* eslint-disable */
// @ts-nocheck

import React from "react";
import { Dropdown, FormLabel } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";

interface IProps {
  className?: string;
  label: string;
  selectedItem: any;
  items: Array;
  onChange: (value?: any) => void;
  tooltipText?: string;
  required?: boolean;
  disabled?: boolean;
}

const DropdownField = ({
  className,
  label,
  selectedItem,
  items,
  onChange,
  tooltipText,
  required,
  disabled = false,
}: IProps) => {
  return (
    <div className="form-wrapper">
      <div className="form-label">
        <FormLabel data-cy={`${label.replaceAll(" ", "")}-dropdownlabel`}>
          {label} {required == true ? "*" : null}
        </FormLabel>
        {tooltipText ? (
          <FieldTooltip
            fieldName={`${label.replaceAll(" ", "")}-`}
            label={tooltipText}
          />
        ) : null}
      </div>
      <Dropdown
        className={
          selectedItem ? className : `dropdown-placeholder ${className}` // Show placeholder if no item is selected
        }
        label={label}
        selectedItem={selectedItem}
        items={items}
        onChange={(e) => {
          onChange(e);
        }}
        required={required}
        disabled={disabled}
        data-cy={`${label.replaceAll(" ", "")}-input`}
      />
    </div>
  );
};

export default DropdownField;
